import $ from 'jquery';

$('.sitewidewarning__close').click(function() {
  $(this).closest('.sitewidewarning').slideToggle();
});
